import { useEffect, useState } from "react";
import Pagination from "../../../components/Pagination";

import Filters from "./Filters";
import ResultTable from "./ResultTable";
import { GlobalService } from "../../../services/GlobalService";

export default function CandidatePage({ match }) {
  const [search, setSearch] = useState({});
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchCandidateResult, setSearchCandidateResult] = useState([]);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    let searchTerm = match.params.searchTerm;

    if (searchTerm) {
      setSearch({ nameOrEmail: searchTerm });
      GlobalService.SearchCandidate(pageSize, pageNumber, {
        nameOrEmail: searchTerm
      }).then((data) => {
        setSearchCandidateResult(data.page);
        setTotalPages(Math.ceil(data.total / pageSize));
      });
    }
  }, []);

  useEffect(() => {
    GlobalService.SearchCandidate(pageSize, pageNumber, search).then((data) => {
      setSearchCandidateResult(data.page);
      setTotalPages(Math.ceil(data.total / pageSize));
    });
  }, [pageNumber, pageSize, search.orderBy, search.order]);

  return (
    <>
      {" "}
      <Filters
        setSearchCandidateResult={setSearchCandidateResult}
        search={search}
        setSearch={setSearch}
        setTotalPages={setTotalPages}
        pageSize={pageSize}
        pageNumber={pageNumber}
      />
      <ResultTable
        searchCandidateResult={searchCandidateResult}
        setSearch={setSearch}
        search={search}
      />
      <Pagination
        totalPages={totalPages}
        setPageNumber={setPageNumber}
        pageNumber={pageNumber}
        setPageSize={setPageSize}
      />
    </>
  );
}
